import readableContentType from '../plugins/readable-content-type';

(function($) {

    $.fn.buildContentTeaser = function(response, responseCode, $contentMarkup, $prependLocation, openInNewTab) {

        var contentItem = {};

        $.each(responseCode, function(key, content) {
            contentItem.id = content.id;
            contentItem.title = content.title;
            contentItem.author = content.author_full_name;
            contentItem.summary = content.plaintext_summary;
            contentItem.img = content.thumbnail_image_url;
            contentItem.ageUK = content.tcm_age_range;
            contentItem.ageUS = content.usa_age_range;
            contentItem.CMS_created = content.cms_created;
            contentItem.Slug = content.slug;
            contentItem.type = content.type;
            contentItem.count = content.drill_count;

            buildDrills();
        });

        function buildDrills() {
            var $newItem = $contentMarkup.clone().removeAttr('hidden');
            var $ageTag = $newItem.find('.teaser-type .teaser-age-range');
            var baseUrl = window.location.origin;
            var builtSlug = baseUrl + contentItem.Slug;
            const contentTypeReadable = readableContentType(contentItem.type);

            $newItem.removeAttr('id');
            $newItem.find('.content-teaser').children().not('.double-actions').wrapAll('<a href="' + builtSlug + '" class="height-100"></a>');
            if (openInNewTab === true) {
                $newItem.find('a').attr('target', '_blank');
            }
            $newItem.find('.content-teaser').attr('data-content-id', contentItem.id);
            $newItem.find('.content-teaser').attr('data-content-type', contentItem.type);
            $newItem.find('.teaser-type .content-type').html(contentTypeReadable);
            $newItem.find('.teaser-type').addClass(contentItem.type);

            $newItem.find('.teaser-title').html(contentItem.title);
            $newItem.find('.teaser-info .teaser-author').text(contentItem.author);
            $newItem.find('.teaser-info-grey .teaser-drill-count').html(contentItem.count);
            $newItem.find('.teaser-summary').html(contentItem.summary);

            $newItem.find('.teaser-thumbnail').css('background-image', 'url(' + contentItem.img + ')');
            $newItem.find('.toggle-btns').attr('data-model-id', contentItem.id);


            if (contentItem.ageUK || contentItem.ageUS) {
                if ($('body').attr('data-user-location') == 'gb') {
                    $ageTag.html(contentItem.ageUK);
                } else {
                    $ageTag.html(contentItem.ageUS);
                }
            } else {
                $ageTag.attr('hidden', true);
            }

            $prependLocation.prepend($newItem);

            setTimeout(function() {
                $newItem.find('.content-teaser').addClass('loaded');
            }, 800);
        }
    };

}(jQuery));



// WEBPACK FOOTER //
// ./library/js/plugins/build-content-teaser.js